// extracted by mini-css-extract-plugin
module.exports = {"margin":"LegendeAbsenceContent_margin__zgCmQ","motif":"LegendeAbsenceContent_motif__O8Zjw"};